<template>
    <div class="body">
        <video class="video" :src="video.videoPath" :poster="video.cover" controls/>
    </div>
</template>

<script>
export default {
    name: 'VideoPlayer',
    props: {
        video: {
            type: Object,
            default: () => {
                return {
                    cover: '',
                    url: ''
                }
            }
        }
    },
}
</script>

<style scoped>
.body {
    width: 100vw;
    height: 56vw;
}
.video{
    width: 100vw;
    height: 56vw;

}
</style>
